import {forEach} from "../helpers";
import axios from "axios";

export function loginUser(form) {
  let params = {};
  forEach(form.elements, el => {
    if (!el.name) return;
    params[el.name] = el.value
  });
  axios.post('/api/v1/user-session/', params)
    .then(response => {
      if (!response.data.success) throw response.data.errors[0].message;
      console.log(response);
      form.dispatchEvent(new CustomEvent("user-login", {'detail': {USER: response.data.data.USER}}));
    })
    .catch(error => {
      console.log(error);
      form.classList.remove('is-loading');
      const serverErrorEl = form.querySelector('.server-error-message');
      serverErrorEl.textContent = error;
    });
}
